import { DesignationsSelectionSidebar } from "react-migration/domains/constraints/designation/components/Designations/DesignationsSelectionSidebar";
import { usePlanningAuthorityLayerTypeContext } from "./PlanningAuthorityContext";
import { LayerTypeSelectionSidebarProps } from "../../types";

export function PlanningAuthoritySelectionSidebar(props: LayerTypeSelectionSidebarProps) {
  const { constraintsStore } = usePlanningAuthorityLayerTypeContext();

  return <DesignationsSelectionSidebar {...props} constraintsStore={constraintsStore} />;
}
